import JobCollection from './JobCollection';

export {
    JobCollection
};



// WEBPACK FOOTER //
// ./plugins/jobs/web_client/collections/index.js